import Card from 'components/Card/Card';
import CardContent from 'components/CardContent/CardContent';
import Typography from 'components/Typography/Typography';
import styles from '../RequestDetails.module.scss';
import {get} from 'lodash';
import {Fragment} from 'react/jsx-runtime';

function Rx2GoDetails({data, isLoading}: {data: any; isLoading: boolean}) {
  return (
    <Card>
      <CardContent px="sm" pt="md" pb="sm">
        <Typography component="p" variant="label">
          RX2GO Details
        </Typography>
        {isLoading ? (
          <div>
            <Typography component="p" variant="label">
              Loading...
            </Typography>
          </div>
        ) : (
          <Fragment>
            <div style={{marginTop: 10}} className={styles.row}>
              <p style={{margin: 0, padding: 0, fontSize: 14}}>RX2GO ID:</p>
              <p style={{margin: 0, padding: 0, fontSize: 14}}>
                <b>{get(data, 'uid', '')}</b>
              </p>
            </div>
            <div style={{marginTop: 10}} className={styles.row}>
              <p style={{margin: 0, padding: 0, fontSize: 14}}>Status</p>
              <p style={{margin: 0, padding: 0, fontSize: 14}}>
                <b>{get(data, 'status', '')}</b>
              </p>
            </div>
            <div style={{marginTop: 10}} className={styles.row}>
              <p style={{margin: 0, padding: 0, fontSize: 14}}>Tracking Link</p>
              <p style={{margin: 0, padding: 0, fontSize: 14}}>
                <a
                  href={get(data, 'tracking_link', '')}
                  target="_blank"
                  rel="noreferrer"
                >
                  Link
                </a>
              </p>
            </div>
          </Fragment>
        )}
      </CardContent>
    </Card>
  );
}
export default Rx2GoDetails;
